export const LOADING = 'LOADING'
// auth 
export const CURRENT_USER = 'CURRENT_USER'
export const AUTHENTICATE = 'AUTHENTICATE'
// files
export const LOAD_MY_FILES = 'LOAD_MY_FILES'
export const ADD_FILE = 'ADD_FILE'
export const LOAD_SHARED_FILES = 'LOAD_SHARED_FILES'
export const UPLOAD = 'UPLOAD'
export const SHARE = 'SHARE'
export const SHARE_WITH_LINK = 'SHARE_WITH _LINK'
export const CHANGE_ACCESS = 'CHANGE_ACCESS'
export const STARRED = 'STARRED'
export const RENAME = 'RENAME'
export const SORT = 'SORT'
export const DESCRIPTION = 'DESCRIPTION'
export const DELETE = 'DELETE'
export const DELETE_SHARED = 'DELETE_SHARED'
export const DOWNLOAD = 'DOWNLOAD'

